export default __webpack_public_path__ + "static/media/al.41b54c31.svg";